<mat-tab-group>
  @if (userService.hasRole('Admin') || userService.hasRole('Office')) {
    <mat-tab [label]="'reportCard.tabs.certificateOverview' | translate">
      <app-certificate-overview></app-certificate-overview>
    </mat-tab>
  }

  <mat-tab [label]="'reportCard.tabs.certificateQuery' | translate">
    <app-certificate-query></app-certificate-query>
  </mat-tab>
</mat-tab-group>
